<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_216_1935)">
      <path
        d="M30.1514 19.1367C28.3936 9.6123 20.8877 2.10645 11.3633 0.348633C10.4375 0.175781 9.49707 0.0585938 8.53906 0L6.0166 9.41895L5.74414 10.4297L5.47461 11.4316L5.43652 11.5752L5.3457 11.9092L4.58691 14.7393L4.2793 15.8906L4.00684 16.9014L0.5 30L9.13379 27.6855L10.1973 27.4014L11.501 27.0527L13.9883 26.3848L15.292 26.0361L16.3584 25.752L25.7803 23.2266L30.5 21.9609C30.4414 21.0029 30.3213 20.0625 30.1514 19.1367ZM7.42578 11.3994C8.31934 11.7305 8.96094 12.583 8.96094 13.5908C8.96094 14.8828 7.90918 15.9346 6.61719 15.9346C6.48242 15.9346 6.35059 15.917 6.22168 15.8936L7.42578 11.3994ZM5.73242 17.7129C6.0166 17.7744 6.3125 17.8066 6.61719 17.8066C8.94629 17.8066 10.8359 15.917 10.8359 13.5879C10.8359 11.71 9.6084 10.1221 7.91504 9.57422L8.68555 6.69434C12.2363 7.03711 15.5557 8.4873 18.2305 10.8662C16.1621 11.1357 14.5625 12.9023 14.5625 15.0439C14.5625 17.373 16.4521 19.2627 18.7812 19.2627C20.4512 19.2627 21.8896 18.29 22.5723 16.8867C23.2344 18.4424 23.6592 20.0977 23.8262 21.8086L16.3291 23.8184C15.8721 21.9844 14.2168 20.6221 12.2393 20.6221C9.91016 20.6221 8.02051 22.5117 8.02051 24.8408C8.02051 25.2422 8.0791 25.6318 8.18457 26.001L3.15137 27.3486L5.73242 17.7129ZM21.1221 15.0469C21.1221 16.3389 20.0703 17.3906 18.7783 17.3906C17.4863 17.3906 16.4346 16.3389 16.4346 15.0469C16.4346 13.7549 17.4863 12.7031 18.7783 12.7031C20.0703 12.7031 21.1221 13.7549 21.1221 15.0469ZM9.89844 24.8408C9.89844 23.5488 10.9502 22.4971 12.2422 22.4971C13.3496 22.4971 14.2725 23.2705 14.5186 24.3047L10.0098 25.5117C9.94238 25.2979 9.89844 25.0752 9.89844 24.8408ZM9.17773 4.86328L9.93945 2.01855C10.2998 2.06543 10.6631 2.12402 11.0234 2.19141C19.751 3.80273 26.6973 10.752 28.3115 19.4795C28.3789 19.8398 28.4346 20.2002 28.4844 20.5635L25.6631 21.3193C24.6641 12.6885 17.8115 5.84473 9.17773 4.86328Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_216_1935">
        <rect
          width="30"
          height="30"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Pizza',
} as DefineComponent
</script>
